export enum CreditAppStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    SUBMITTED = 'SUBMITTED',
    PENDING = 'PENDING'
}
